export default {"src":"/_next/static/media/last-viewed.815e26e5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};